import { render, staticRenderFns } from "./CharacterRoomArtPvp.vue?vue&type=template&id=0730db43&scoped=true&"
import script from "./CharacterRoomArtPvp.vue?vue&type=script&lang=js&"
export * from "./CharacterRoomArtPvp.vue?vue&type=script&lang=js&"
import style0 from "./CharacterRoomArtPvp.vue?vue&type=style&index=0&id=0730db43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0730db43",
  null
  
)

export default component.exports